import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PriorityFilterList } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-pay-and-distance-offer-lookup',
  templateUrl: './pay-and-distance-offer-lookup.component.html',
  styleUrls: ['./pay-and-distance-offer-lookup.component.css']
})
export class PayAndDistanceOfferLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.payAndDistanceSelected = [];
      this.clearPayAndDistance();
    }
  }
  @Input() placeholder = 'Pay and Distance';
  @Input() isdisabled = false;
  @Input() filterObjValue = 'payAndDistance';
  @Input() isMultipleSelected = true;
  @Input() viewType = '';

  @Output() getPayAndDistanceObj: EventEmitter<any> = new EventEmitter;


  payAndDistanceSelected = [];
  minPay = 0;
  maxDistance = 50;
  /**
   * @constructor
   * Represents a PriorityLookupComponent.
   */
  constructor() {
  }

  ngOnInit() {
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.payAndDistanceSelected = (preselected && preselected[this.filterObjValue]) ? preselected[this.filterObjValue] : '';
    if (this.payAndDistanceSelected && this.payAndDistanceSelected['minPay'] !== undefined) {
      this.minPay = this.payAndDistanceSelected['minPay'];
    }
    if (this.payAndDistanceSelected && this.payAndDistanceSelected['maxDistance'] !== undefined) {
      this.maxDistance = this.payAndDistanceSelected['maxDistance'];
    }
  }

  onPayAndDistanceChange() {
    //this.getPayAndDistanceObj.emit({ minPay: this.minPay, maxDistance: this.maxDistance }); //uncomment if maxDistance is needed
    this.getPayAndDistanceObj.emit({ minPay: this.minPay });
  }

  clearPayAndDistance() {
    this.payAndDistanceSelected = [];
    this.minPay = 0;
    this.maxDistance = 0;
    //this.getPayAndDistanceObj.emit({ minPay: this.minPay, maxDistance: this.maxDistance });//uncomment if maxDistance is needed
    this.getPayAndDistanceObj.emit({ minPay: this.minPay });
  }

  increase(type: string) {
    if (type === 'minPay' && this.minPay < 5000) this.minPay += 1;
    if (type === 'maxDistance' && this.maxDistance < 200) this.maxDistance += 1;
    this.getPayAndDistanceObj.emit({ minPay: this.minPay });
  }

  decrease(type: string) {
    if (type === 'minPay' && this.minPay > 0) this.minPay -= 1;
    if (type === 'maxDistance' && this.maxDistance > 1) this.maxDistance -= 1;
    this.getPayAndDistanceObj.emit({ minPay: this.minPay });
  }


}
